import thumbnailImg from 'Static/thumbnails/screenshot--weather.png';

export default {
  slug: 'weather',
  title: 'Weather',
  seriesNumber: '6',
  published: true,
  thumbnailImg,
  subject: 'Physical Sciences',
  graphicFileName: 'Image_Weather.png',
  graphicAlt:
    'App screenshot of Weather depicting a landmass and its weather systems',
  iconFileName: 'Icon_Weather.png',
  iconLargeFileName: 'Icon_Weather@2x.png',
  iconAlt: 'App icon for Weather depicting a cloud',
  description:
    'Topics covered include weather, atmospheric science, meteorology, water cycle, precipitation, temperature, clouds.',
  briefDescription: 'Learn about meteorology & more.',
  supportedLanguages: [
    'en',
    'af',
    'ar',
    'bg',
    'bn',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fa',
    'fi',
    'fr',
    'hi',
    'hr',
    'ht',
    'hu',
    'id',
    'it',
    'ja',
    'km',
    'ko',
    'ms',
    'nb',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sq',
    'sr',
    'sv',
    'ta',
    'th',
    'tl',
    'tr',
    'uk',
    'ur',
    'uz',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'Scene_WaterCycle',
    'Loupe_WaterCycle',
    'SunAndTemperature',
    'Scene_Temperature',
    'Loupe_WarmAirMolecules',
    'Loupe_ColdAirMolecules',
    'Loupe_TemperatureTable',
    'Loupe_TemperatureDog',
    'Loupe_TemperatureWindow',
    'Moisture',
    'Scene_Rain',
    'Loupe_Snowflake',
    'Loupe_Raindrop',
    'Loupe_WaterMoleculesInCoolAir',
    'Loupe_WaterMoleculesInWarmAir',
    'Wind',
    'Scene_Tornado',
    'Loupe_TornadoHouse',
    'Scene_Hurricane',
    'Loupe_HurricaneHouse',
    'Clouds',
    'Loupe_HotAirOnWater',
    'Loupe_HotAirAndLand',
    'Scene_Cloud',
  ],
  featuredPrintables: ['weather_water_cycle'],
  printables: [
    'weather_cold_warm',
    'weather_journal',
    'concept_map',
    'generating_questions',
  ],
  topics: ['water_cycle', 'sun_and_temp', 'severe_weather', 'states_of_matter'],
  deepLinks: {
    'water-cycle': 'Scene_Planet',
    temperature: 'Scene_Temperature',
  },
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/weather-by-tinybop/id1076985045',
    googlePlayLink:
      'https://play.google.com/store/apps/details?id=com.tinybop.theweather',
  },
};
